import { render, staticRenderFns } from "./GithubModal.vue?vue&type=template&id=77bdb07b&"
import script from "./GithubModal.vue?vue&type=script&lang=js&"
export * from "./GithubModal.vue?vue&type=script&lang=js&"
import style0 from "./GithubModal.vue?vue&type=style&index=0&id=77bdb07b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports